
import Vue from 'vue'
import inViewportDirective from 'vue-in-viewport-directive'
import * as snippets from '../snippets';
inViewportDirective.defaults.margin = '-20% 0%'
Vue.directive('viewport', inViewportDirective)
export default {
  data(){
    return {
      sectionID: ''
    }
  },
  components: {
    ...snippets
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  created(){
    this.sectionID = this.$vnode.tag
  },
  mounted(){
    this.sectionID = this.$vnode.tag
  },
  methods: {
    srcset(img){
      if(!img || img.trim().length === 0) return null;

      if(!img.endsWith('jpg') && !img.endsWith('png') && !img.endsWith('jpeg')) return null;

      const img2x = img.replace(/.(jpg|png|jpeg|svg)$/,function(x){
        return '@2x' + x;
      })
      return img + ' 1x, ' + img2x + ' 2x';
    }
  }
}
